// --- Modules
import Node, { payload } from './Node';

class Router extends Node {
  constructor(opts) {
    super(opts);

    Object.defineProperty(this, 'nodeClass', {
      enumerable: false,
      configurable: false,
      writable: false,
      value: 'Router'
    });
  }
};

export default {
  create: (opts) => {
    let item = new Router(opts);
    payload.nodes.push(item);
    return payload.nodes[payload.nodes.length - 1];
  }
};
